import { Translation } from '@/helpers'
import { ALLOWED_IMAGE_TYPES, ALLOWED_VIDEO_TYPES } from '@/data'

export const PicImageUpload = (props: ComponentImageUploadFunctionProps) => {
    const {
        e,
        fileInputRef,
        Form,
        SetState,
        Notification
    } = props

    try {
        if (e && e?.target?.files) {
            const { type, size } = e.target.files[0]

            if (size > 10 * 1024 * 1024) {
                Notification(Translation('image-to-large'))
                setTimeout(() => SetState({ Loading: false }), 2000)
            }

            else {
                const acepted = ALLOWED_IMAGE_TYPES.split(', ').includes(type)

                if (acepted) {
                    const file = e.target.files[0]
                    const reader = new FileReader()

                    reader.onload = () => {
                        const image = new Image()

                        if (typeof reader.result === 'string') {
                            image.src = reader.result
                        }

                        image.onload = async () => {
                            if (image.width < 50 || image.height < 50) {
                                Notification(Translation('image-to-small'))
                                setTimeout(() => SetState({ Loading: false }), 2000)
                            }

                            else {
                                const canvas = document.createElement('canvas')
                                const ctx = canvas.getContext('2d')

                                const newWidth = image.width / 2.5
                                const newHeight = image.height / 2.5

                                canvas.width = newWidth
                                canvas.height = newHeight

                                if (ctx) {
                                    ctx.drawImage(image, 0, 0, canvas.width, canvas.height)

                                    const imageData = ctx.getImageData(0, 0, canvas.width, canvas.height)
                                    const pixels = imageData.data

                                    let isTransparent = false

                                    for (let i = 0; i < pixels.length; i += 4) {
                                        const alpha = pixels[i + 3]

                                        if (alpha < 255) {
                                            isTransparent = true
                                            break
                                        }
                                    }

                                    const compressedDataUrl = canvas.toDataURL(type, 0.75)

                                    const compressedImage = await fetch(compressedDataUrl)
                                    const blob = await compressedImage.blob()

                                    const compressedFile = new File([blob], file.name, { type: file.type })

                                    if (e?.currentTarget?.value) e.currentTarget.value = ''
                                    if (fileInputRef.current) fileInputRef.current.value = ''

                                    if (!isTransparent) {
                                        const form = structuredClone(Form)
                                        form.Image = compressedFile

                                        SetState({
                                            Form: form,
                                            Loading: false
                                        })
                                    }

                                    else Notification(Translation('transparent-background'))

                                    setTimeout(() => SetState({ Loading: false }), 1500)
                                }

                                else {
                                    Notification(Translation('photo-checking-failed'))
                                    setTimeout(() => SetState({ Loading: false }), 1500)
                                }
                            }
                        }
                    }

                    reader.readAsDataURL(file)
                }

                else SetState({ Loading: false })
            }
        }
    }

    catch (err) {
        if (e?.currentTarget?.value) e.currentTarget.value = ''
        if (fileInputRef.current) fileInputRef.current.value = ''
    }
}

export const VideoUpload = (props: ComponentVideoUploadFunctionProps) => {
    const {
        e,
        fileInputRef,
        Form,
        SetState,
        Notification
    } = props

    try {
        if (e && e?.target?.files) {
            const { type, size } = e.target.files[0]

            if (size > 10 * 1024 * 1024) {
                Notification(Translation('video-to-large'))
                setTimeout(() => SetState({ Loading: false }), 2000)
            }

            else {
                const acepted = ALLOWED_VIDEO_TYPES.split(', ').includes(type)

                if (acepted) {
                    const file = e.target.files[0]

                    if (type === 'video/quicktime') {
                        const blob = new Blob([file], { type: file.type })

                        const form = structuredClone(Form)
                        form.Video = blob

                        SetState({
                            Form: form,
                            Loading: false
                        })
                    }

                    else {
                        const reader = new FileReader()

                        reader.onload = () => {
                            const video = document.createElement('video')

                            if (typeof reader.result === 'string') {
                                video.src = reader.result
                            }

                            video.onloadedmetadata = async () => {
                                if (video.duration > 30) {
                                    Notification(Translation('video-to-long'))
                                    setTimeout(() => SetState({ Loading: false }), 2000)
                                }

                                else {
                                    if (e?.currentTarget?.value) e.currentTarget.value = ''
                                    if (fileInputRef.current) fileInputRef.current.value = ''

                                    const form = structuredClone(Form)
                                    form.Video = file

                                    SetState({
                                        Form: form,
                                        Loading: false
                                    })
                                }
                            }

                            video.onerror = () => {
                                Notification(Translation('video-checking-failed'))
                                SetState({ Loading: false })
                            }
                        }

                        reader.readAsDataURL(file)
                    }
                }

                else SetState({ Loading: false })
            }
        }
    }

    catch (err) {
        if (e?.currentTarget?.value) e.currentTarget.value = ''
        if (fileInputRef.current) fileInputRef.current.value = ''
    }
}
